import { sendErrorMetric } from "@expert/cloudwatch-metrics";

const VOICE_RUNTIME_ACTIONS = {
    /** `acceptTask` failed for a voice contact. */
    acceptContactFailed: "accept_contact_failed",
    holdCallFailed: "hold_call_failed",
    resumeCallFailed: "resume_call_failed",
    muteCallFailed: "mute_call_failed",
    /** `redirectCallToSIP` found no matching Quick Connect, or addConnection failed. */
    redirectSipFailed: "redirect_sip_failed",
    redirectTfnFailed: "redirect_tfn_failed",
    outboundCallFailed: "outbound_call_failed",
    missedCallCleanupFailed: "missed_call_cleanup_failed",
    /** Auto-ack of a Mindful (VHT) callback via DTMF failed. */
    mindfulCallbackFailed: "mindful_callback_failed",
    contactError: "contact_error",
    refreshTaskFailed: "refresh_task_failed",
    conferenceAddParticipantFailed: "conference_add_participant_failed",
    /** `hangupCall`, `leaveConference`, or `endConference` failed. */
    hangupFailed: "hangup_failed",
    dtmfFailed: "dtmf_failed",
    /** Failed to clear a voice contact during SDK init. */
    initClearFailed: "init_clear_failed",
    updateParticipantHoldStateFailed: "update_participant_hold_state_failed",
    surveyTransferFailed: "survey_transfer_failed",
    completeTaskFailed: "complete_task_failed",
    wrapupTaskFailed: "wrapup_task_failed",
    softphoneError: "softphone_error",
} as const;

export type VoiceRuntimeAction = (typeof VOICE_RUNTIME_ACTIONS)[keyof typeof VOICE_RUNTIME_ACTIONS];

/**
 * Emits runtime errors for voice metrics. Can be one of the documented `VoiceRuntimeAction` types.
 * See docs/voice-runtime-errors-metric.md for more information.
 * */
export function emitVoiceRuntimeError(action: VoiceRuntimeAction, partner?: string): void {
    void sendErrorMetric("VoiceRuntimeError", {
        channel: "voice",
        communicationProvider: "amazon-connect",
        action,
        ...(partner && { partner }),
    });
}
